<template>
  <v-app>
    <v-container class="pa-0">
      <v-row
        class="banner"
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-responsive :aspect-ratio="1065/531">
            <template v-if="user.login_enable">
              <navigation
                :class="{ 'is-mini': miniNavigation }"
                v-on:select-user="showUserPanel = !showUserPanel"
                :logo="brand.logo"
                  ></navigation>
            </template>
            <v-img :src="brand.image"/>
          </v-responsive>
        </v-col>
      </v-row>
      <v-row
        class="mt-n5"
        no-gutters
        justify="center"
      >
        <user-panel
          v-if="showUserPanel"
          v-body-scroll-lock="showUserPanel"
          v-on:close="showUserPanel = false"
        ></user-panel>
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <v-card
            rounded="xl"
            elevation="8"
          >
            <v-card-title
              class="font-weight-bold"
            >
              <v-container>
                <v-row
                  align="center"
                >
                  <v-col
                    cols="3"
                  >
                    <v-avatar size="100%">
                      <v-img :src="brand.logo"/>
                    </v-avatar>
                  </v-col>
                  <v-col
                    cols="auto"
                  >
                    {{ brand.name }}
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>

            <v-card-text>
              <v-container class="py-0">
                <v-row>
                  <v-col>
                    <div
                      class="mt-4 text-body-2 grey--text text--darken-1"
                    >
                      <vue-markdown :source="brand.welcome" :options="{ linkify: true }"/>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-text class="px-0">
              <v-list
                flat
                class="mb-2"
              >
                <v-subheader>服務據點</v-subheader>
                <v-list-item
                  v-for="store in stores"
                  v-bind:key="store.token"
                  :to="{ name: 'Store', params: { storeId: store.token } }"
                >
                  <v-list-item-content>
                    <v-container class="pa-0">
                      <v-row dense>
                        <v-col
                          cols="3"
                        >
                          <v-avatar
                            width="100%"
                            height="100%"
                            rounded="lg"
                          >
                            <v-img
                              width="100%"
                              :aspect-ratio="1065/531"
                              :src="store.image"
                            />
                          </v-avatar>
                        </v-col>
                        <v-col
                          cols="9"
                        >
                          <v-list-item-title
                            class="font-weight-bold mb-2"
                          >{{ store.name }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ store.address }}
                          </v-list-item-subtitle>

                          <div class="d-flex mt-2">
                            <v-icon
                              class="mr-2"
                              small
                            >mdi-library</v-icon>
                            <div class="flex-grow-1">
                              <v-chip
                                class="mr-2"
                                v-for="service in store.services"
                                v-bind:key="service.token"
                                small
                              >
                                {{ service.name }}
                              </v-chip>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon color="grey lighten-1">mdi-trending-neutral</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
        >
          <div class="my-4 text-center text-caption text--secondary">
            bookNow.tw ©️ All Rights Reserved.<br>
            <span v-if="brand.name">{{ brand.name}}</span>
            <span v-else>品牌</span>
            保留接受或拒絕預訂之權力
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Vue from 'vue';
import Axios from '@/helpers/axios';
import VueMarkdown from 'vue-markdown-render';
import navigation from '@/components/Navigation.vue';
import VBodyScrollLock from 'v-body-scroll-lock';
import userPanel from '@/components/UserPanel.vue';
import { mapState } from 'vuex';

Vue.use(VBodyScrollLock);

export default {
  name: 'Brand',
  components: {
    VueMarkdown,
    navigation,
    userPanel,
  },
  beforeMount() {
    const data = {
      brandId: this.$route.params.brandId,
    };

    Axios({
      method: 'POST',
      url: 'brand',
      data,
    })
      .then((api) => {
        if (api.status === 200) {
          this.brand = api.data.brand;
          this.stores = api.data.stores;
        }
      });
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  data() {
    return {
      miniNavigation: false,
      showNavigation: 'none',
      showUserPanel: false,
      brand: {
        name: '',
        logo: '',
        image: '',
        welcome: '',
      },

      stores: [
        {
          token: '',
          name: '',
          address: '',
          tel: '',
          image: '',
          service: [
            {
              token: '',
              name: '',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
.banner
  position: sticky
  top: 0
</style>
